import { FC, FocusEvent, useEffect } from "react";
import { useFormContext } from "react-hook-form";

import { ITemplateRowBlockControl } from "@framework/types";
import { NumberInput } from "@framework/mui-inputs-core";
import { findClosestNumber, parseRange } from "./utils";

export interface IEditIntInputProps {
  control: ITemplateRowBlockControl;
  disabled?: boolean;
}

export const EditIntInput: FC<IEditIntInputProps> = props => {
  const { control, disabled } = props;

  const form = useFormContext();
  const { __name: name, __label: label } = control;

  const range = control.__range ? parseRange(control.__range) : null;

  const handleOnBlur = (e: FocusEvent<HTMLInputElement>): void => {
    const value = e.target.value ? Number(e.target.value) : 0;
    const newValue = range ? findClosestNumber(range, value) : value;
    form.setValue(name, newValue, { shouldTouch: true, shouldDirty: true });
    void form.trigger(name);
  };

  useEffect(() => {
    return () => {
      form.resetField(name);
    };
  }, []);

  return (
    <NumberInput
      name={name}
      onBlur={handleOnBlur}
      label={label}
      placeholder={control.__default || "1"}
      allowNegative={false}
      enableKeyboardSpinPreview
      variant="outlined"
      disabled={disabled}
    />
  );
};
